export var ListStyleTypeProps;
(function (ListStyleTypeProps) {
    ListStyleTypeProps["none"] = "none";
    ListStyleTypeProps["ordered"] = "decimal";
    ListStyleTypeProps["unordered"] = "disc";
    ListStyleTypeProps["lowerAlpha"] = "lower-alpha";
    ListStyleTypeProps["lowerLatin"] = "lower-latin";
})(ListStyleTypeProps || (ListStyleTypeProps = {}));
